import * as type from '../../types/trans';

export const cvlData = (data) => {
    console.log("cvlData data", data);
    return {
        type: type.SAVE_CVL_DATA,
        payload: data
    }
}
export const authDetails = (data) => {
    return {
        type: type.AUTHRESP,
        payload: data
    }
}
export const userDetail = (data) => {
    console.log("userDetail", data);
    return {
        type: type.USER_DETAIL,
        payload: data
    }
}

export const updateGuest = (data) => {
    console.log("updateGuest data", data);
    return {
        type: type.UPDATE_GUEST_MENU,
    }
}

export const resetGuest = (data) => {
    console.log("resetGuest data", data);
    return {
        type: type.RESET_GUEST_MENU,
    }
}

export const getParams = (data) => {
    return {
        type: type.GET_PARAMS,
        payload: data
    }
}